<div [style.display]="showDisplay ? 'block': 'none'">
    <button class="chat-btn" type="button" (click)="close()">x</button>
    <iframe src="https://sac-clubemontreal.ascbrazil.com.br/Chat/id/Clube_Montreal"></iframe>
  </div>